import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';
import type { PontoEncontro, ZasEdificacao } from '@/domain';

export interface PaebmMapaData {
  edificacoes: ZasEdificacao[];
  pontosEncontro: PontoEncontro[];
  isLoading: boolean;
  error: Error | null;
}

/**
 * Camadas PAEBM do mapa (M2) — edificações ZAS + pontos de encontro (GUPM-195).
 * Dado de referência (raramente muda) → sem polling. Lê via `PaebmDataSource`
 * (nunca `supabase.from` no componente — regra #2).
 */
export function usePaebmMapa(): PaebmMapaData {
  const { paebm } = useDataSources();

  const edi = useQuery({
    queryKey: ['paebm', 'edificacoes-zas'],
    queryFn: () => paebm.listEdificacoesZas(),
  });
  const pe = useQuery({
    queryKey: ['paebm', 'pontos-encontro'],
    queryFn: () => paebm.listPontosEncontro(),
  });

  return {
    edificacoes: edi.data ?? [],
    pontosEncontro: pe.data ?? [],
    isLoading: edi.isLoading || pe.isLoading,
    error: (edi.error ?? pe.error) as Error | null,
  };
}
